export class ARMiscInvoicePaymentExistsParameterDto {
    customerId: string;
    checkNumber: string;
    paymentAmountReceived: number;
    communityId: number;
    managementCompanyId: number;
}
